import * as Yup from 'yup';

export const clientSchema = Yup.object().shape({
  surname: Yup.string()
    .required("Обов'язкове поле")
    .matches(/^[a-zA-Zа-яА-ЯёЁіІїЇєЄ'’-]+$/, 'Тільки літери, апостроф та дефіз')
    .trim(),
  name: Yup.string()
    .required("Обов'язкове поле")
    .matches(/^[a-zA-Zа-яА-ЯёЁіІїЇєЄ'’-]+$/, 'Тільки літери, апостроф та дефіз')
    .trim(),
});
